// This icon file is generated automatically.
var PPhoneOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.7 2.73l-1.66-1.66a1.07 1.07 0 00-1.52 0l-1.8 1.79a1.08 1.08 0 000 1.52l1.4 1.4A6.34 6.34 0 015.8 9.14l-1.4-1.4a1.07 1.07 0 00-1.53 0l-1.8 1.79a1.08 1.08 0 000 1.52l1.67 1.67a1.87 1.87 0 001.62.52 10.83 10.83 0 005.78-3.1 10.87 10.87 0 003.1-5.78c.1-.6-.1-1.2-.53-1.62zm-.58 1.43a9.72 9.72 0 01-2.79 5.17 9.71 9.71 0 01-5.17 2.79.73.73 0 01-.64-.2L1.9 10.27l1.73-1.73 1.87 1.87.02.02.33-.13a7.52 7.52 0 004.47-4.46l.12-.34-1.88-1.89 1.73-1.73 1.63 1.63c.17.17.25.4.2.64z", "fill-rule": "nonzero" } }] }, "name": "p-phone", "theme": "outlined" };
export default PPhoneOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PPhoneOutlined.js
// module id = 3533
// module chunks = 0